<template>
    <div
        class="logo top-0 left-0 z-50 transition-all w-32"
        :class="{'hidden': shadow}"
    >
        <inertia-link :href="route('web.home')">
            <tis-logo
                width="200"
                height="auto" />
        </inertia-link>
    </div>
</template>

<script>
import TisLogo from '@whisper/components/TisLogo';

export default {
  name: 'TisHeaderLogo',
  components: {
    TisLogo,
  },
  props: ['shadow'],
};
</script>

<style scoped>

</style>
